export default "/img/LR.526d82599df495a3f293752e936a75b9.png";